<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Computer Science Engineering</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time text-nowrap">Bachelor of Technology (Computer Science Engineering)</td>
                            <td class="time text-nowrap">Master of Technology (Computer Science Engineering)</td>
                            <td class="time text-nowrap">Ph.D Computer Science</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Computer Science Engineering</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Technology (Computer Science Engineering)
                </b>- The B.Tech in Computer Science Engineering program at ARNI School of Technology is designed to
                    teach computer applications, languages, and computation of hardware. The syllabus includes
                    programming languages, mobile app development, hardware or software engineering, data structure, and
                    algorithms. There are eight semesters in this four-year degree program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li>Mathematics-I</li>
                    <li>Linear Algebra and Calculus</li>
                    <li>Introduction to Computer Programming</li>
                    <li>Electrodynamics and Optics</li>
                    <li>Communication Skills</li>
                    <li>Energy and Environmental Engineering</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Core Concepts</p>
                <ul>
                    <li>Mathematics - II</li>
                    <li>Quantum Mechanics and Statistical Mechanics</li>
                    <li>Programme Core I / Discrete Structures</li>
                    <li>Optimizations Techniques</li>
                    <li>Fundamentals of Electronics</li>
                    <li>Branch Specific Course – Essentials of Computer Science</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Applications</p>
                <ul>
                    <li>Mathematics III – Probability and Operations Research</li>
                    <li>Programme Core II / Principles of Programming Languages 4</li>
                    <li>Programme Core III / Data Structures</li>
                    <li>Laboratory I / Data Structures Laboratory</li>
                    <li>Signals & Systems</li>
                    <li>Engineering Thermodynamics</li>
                    <li>Computer Architecture & Microprocessors</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Advanced Core</p>
                <ul>
                    <li> Industrial Economics and Foreign Trades</li>
                    <li>Programme Core IV / Digital Systems Design</li>
                    <li>Programme Core V / Computer Organization</li>
                    <li>Laboratory II / Digital Laboratory</li>
                    <li>Elective I</li>
                    <li>Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Specializations Begins</p>
                <ul>
                    <li> Database Management Systems</li>
                    <li> Theory of Computation</li>
                    <li> Technical Communication</li>
                    <li> Programme Core VI / Formal Languages and Automata Theory</li>
                    <li> Programme Core VII / Design and Analysis of Algorithms</li>
                    <li> Laboratory III / Algorithms Laboratory</li>
                    <li> Elective III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Practical Applications</p>
                <ul>
                    <li> Programme Core VIII / Operating Systems</li>
                    <li> Programme Core IX / Computer Architecture</li>
                    <li> Programme Core X / Database Management Systems</li>
                    <li> Compiler Design</li>
                    <li> Artificial Intelligence and Machine Learning</li>
                    <li> Elective IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII
                </b>: Real-World Training</p>
                <ul>
                    <li> Programme Core XI / Computer Networks</li>
                    <li> Industrial Lecture</li>
                    <li> Laboratory IV / Operating Systems Lab</li>
                    <li> Elective V</li>
                    <li> Professional Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII
                </b>: Research</p>
                <ul>
                    <li> Programme Core XII / Embedded Systems Architectures</li>
                    <li> Principles of Cryptography</li>
                    <li> Embedded Systems Laboratory</li>
                    <li> Elective VI</li>
                    <li> Comprehensive Viva-Voce</li>

                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Master of Technology (Computer Science
                        Engineering) –
                    </b> The M.Tech in Computer Science Engineering program at ARNI School of Technology is designed to
                        educate students about new computer skills in making software, algorithms, and programming to
                        deepen their understanding. This two-year course is divided into four semesters.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester I
                    </b>: Foundational and Advanced Concepts</p>
                    <ul>
                        <li> Computer Science - Mathematical Foundation</li>
                        <li> Big Data Analytics</li>
                        <li> Computer Organization & Architecture</li>
                        <li> Object Oriented Design and Analysis</li>
                        <li> Advanced Data Structure & Algorithm</li>
                        <li> Data Structure & Algorithms Laboratory</li>
                        <li> Elective I</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester II
                    </b>: Specialized Studies</p>
                    <ul>
                        <li> Soft Computing & AI – Latest Trends</li>
                        <li> IPR and Research Methodology</li>
                        <li> Theoretical Foundations of Computer Science</li>
                        <li> Advanced Data Base Laboratory</li>
                        <li> Programming Laboratory</li>
                        <li> Data Warehousing and Data Mining</li>
                        <li> Elective II</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester III
                    </b>: Research and Applications</p>
                    <ul>
                        <li> Processing of Digital Images</li>
                        <li> Use of Python in Data Science</li>
                        <li> Natural Language Processing</li>
                        <li> Machine Language</li>
                        <li> Data Science using Python lab</li>
                        <li> Seminar I</li>
                        <li> Dissertation Phase-I</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester IV

                    </b>: Advanced Core</p>
                    <ul>
                        <li> Elective III</li>
                        <li> Elective IV</li>
                        <li> Seminar II</li>
                        <li> Dissertation Phase-II</li>
                    </ul>
                </div>

                <hr class="border-dashed" style="border:2px;"/>

                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Ph.D (Computer Science Engineering)
                    </b> -The ARNI School of Technology's Ph.D. program in Computer Science Engineering is a combination
                        of advanced coursework and research activities. The curriculum equips enthusiastic individuals
                        with research methodology, computer architecture, data structure, mathematical modeling, and
                        software engineering. It lasts for three to six years and is divided into six semesters.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester I
                    </b> : Coursework</p>
                    <ul>
                        <li>Computer Architecture</li>
                        <li> Complexity and Advanced Algorithms</li>
                        <li> Programming Language Principles</li>
                        <li> Statistical Methods in AI</li>
                        <li>Data Files and Structures</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester II
                    </b> : Practical</p>
                    <ul>
                        <li>Principles of Information Security</li>
                        <li> Design and Analysis of Algorithms</li>
                        <li> Distributed Systems</li>
                        <li>Operating Systems</li>
                        <li> Optimization Methods</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester III
                    </b> : Specializations</p>
                    <ul>
                        <li>Advanced Database Theory and Applications</li>
                        <li> Computer Networks</li>
                        <li> Database Systems</li>
                        <li> Compilers</li>
                        <li> Advanced Algorithms for Graph</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester IV
                    </b> : Research and Development</p>
                    <ul>
                        <li>Data Mining</li>
                        <li> Advanced Operating Systems</li>
                        <li> Cryptology</li>
                        <li>Advanced Image processing</li>
                        <li> Computer Vision</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester V
                    </b> : Research and Dissertation</p>
                    <ul>
                        <li>Information and Coding Theory</li>
                        <li> Database Management Systems</li>
                        <li>Computational Algebra</li>
                        <li> Project/ Assignments</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester VI
                    </b> : Research and Dissertation</p>
                    <ul>
                        <li> Pattern Recognition and Coding Theory</li>
                        <li> Machine Learning: Theory and Practice</li>
                        <li> Research Project</li>
                        <li>Dissertation</li>
                    </ul>
                </div>

                <hr class="border-dashed" style="border:2px;"/>

                <h5 class="text-decoration-underline text-center">Computer Applications</h5>

                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Bachelor of Computer Applications
                    </b> - The Bachelor of Computer Science or BCA program at ARNI School of Technology is designed to
                        educate programming fundamentals to advanced computing. The syllabus includes programming
                        languages, mobile app development, data systems, information security, and web development. This
                        three-year course is divided into six semesters.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester I
                    </b>: Foundation</p>
                    <ul>
                        <li> Fundamentals of IT & Computers</li>
                        <li> English Communication</li>
                        <li> Introduction to Programming Using C</li>
                        <li> Statistics I for BCA</li>
                        <li> Basic Mathematics</li>
                        <li> PC Software Lab</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester II
                    </b>: Core Concepts</p>
                    <ul>
                        <li> Operating Systems and Fundamentals</li>
                        <li> Basic Discrete Mathematics</li>
                        <li> C Language Advanced Concepts</li>
                        <li> Data Structures</li>
                        <li> Case Tools Lab (CIA Only)</li>
                        <li> Organizational Behavior</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester III
                    </b>: Applications</p>
                    <ul>
                        <li> Web-Based Applications</li>
                        <li> Database Management Systems</li>
                        <li> Object Oriented Programming Using C++</li>
                        <li> Introductory Algebra</li>
                        <li> Software Engineering</li>
                        <li> DBMS and Web Technology Lab</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester IV
                    </b>: Advanced Core</p>
                    <ul>
                        <li> Web Designing</li>
                        <li> Introduction to Linux</li>
                        <li> Programming In Java</li>
                        <li> Computer Networks</li>
                        <li> DBMS Project Lab</li>
                        <li> Elective I</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester V
                    </b>: Specializations Begins</p>
                    <ul>
                        <li> Software Engineering – II</li>
                        <li> Python Language</li>
                        <li> eCommerce and Marketing</li>
                        <li> OOAD Using UML</li>
                        <li> Elective II</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester VI
                    </b>: Practical Applications</p>
                    <ul>
                        <li> Client-Server Computing</li>
                        <li> Design And Analysis Of Algorithms</li>
                        <li> Computer Architecture</li>
                        <li> Cloud Computing</li>
                        <li> Multimedia Applications</li>
                    </ul>
                </div>

                <hr class="border-dashed" style="border:2px;"/>

                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Master of Computer Applications </b> –
                        The Master of Computer Science or MCA program at ARNI School of Technology is designed to impart
                        knowledge in the advanced level of computer applications. The program includes topics such as
                        system architecture to AI and varied software and hardware applications. This three-year course
                        is divided into six semesters.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester I
                    </b>: Foundational and Advanced Concepts</p>
                    <ul>
                        <li> Business Communication and Accounting</li>
                        <li> Business Systems and Applications</li>
                        <li> Computer Programming with C</li>
                        <li> Computer Organization & Architecture</li>
                        <li> Advanced Mathematics</li>
                        <li> Micro Programming & Architecture Lab</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester II
                    </b>: Specialized Studies</p>
                    <ul>
                        <li> Information Systems Analysis & Design</li>
                        <li> Data Structures with C</li>
                        <li> Object-Oriented Programming With C++</li>
                        <li> Computer Networks & Data Communication</li>
                        <li> Information Systems Analysis</li>
                        <li> Database Management System I</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester III
                    </b>: Research and Applications</p>
                    <ul>
                        <li> Unix and Shell Programming</li>
                        <li> Statistics and Numerical Techniques</li>
                        <li> Intelligent Systems</li>
                        <li> Operating System</li>
                        <li> Statistics and Numerical Analysis lab</li>
                        <li> Elective I</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester IV
                    </b>: Advanced Core</p>
                    <ul>
                        <li> Software Engineering & TQM</li>
                        <li> Database Management Systems II</li>
                        <li> Operational Research Techniques</li>
                        <li> Multimedia and Graphics</li>
                        <li> Elective II</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester V
                    </b>: Research and Projects</p>
                    <ul>
                        <li> Elective III</li>
                        <li> Elective IV</li>
                        <li> Elective V</li>
                        <li> System Administration and Linux</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester VI
                    </b>: Projects</p>
                    <ul>
                        <li> Project Work</li>
                        <li> Seminar/Internship</li>
                    </ul>
                </div>

                <hr class="border-dashed" style="border:2px;"/>

                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Ph.D Computer Applications </b> –
                        The ARNI School of Technology's Ph.D. program in Computer Applications is a combination of
                        advanced coursework and research activities. The curriculum equips enthusiastic individuals with
                        research methodology, computer architecture, data structure, mathematical modeling, and software
                        engineering. It lasts for three to six years and is divided into six semesters.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester I
                    </b>: Coursework</p>
                    <ul>
                        <li> Project Work</li>
                        <li> Principles of Programme Language</li>
                        <li> Statistical Methods in AI</li>
                        <li> Computer Architecture</li>
                        <li> Advanced Algorithms</li>
                        <li> Structures & Data Files</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester II
                    </b>: Practical</p>
                    <ul>
                        <li> Optimization of Methods</li>
                        <li> Information Security Principles</li>
                        <li> Operating Systems</li>
                        <li> Design and Analysis of Algorithms</li>
                        <li> Distributed Systems</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester III
                    </b>: Specializations</p>
                    <ul>
                        <li> Computer Networks</li>
                        <li> Database Systems</li>
                        <li> Compilers</li>
                        <li> Advanced Algorithms for Graph</li>
                        <li> Advanced Database Theory and Applications</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester IV
                    </b>: Research and Development</p>
                    <ul>
                        <li> Advanced Operating Systems</li>
                        <li> Data Mining</li>
                        <li> Cryptology</li>
                        <li> Image processing</li>
                        <li> Computer Vision</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Semester V
                    </b>: Research</p>
                    <ul>
                        <li> Information and Coding Theory</li>
                        <li> Database Management Systems</li>
                        <li> Computational Algebra</li>
                    </ul>
                </div>

                <hr class="border-dashed" style="border:2px;"/>

                <div class="col-md-12 col-sm-12">
                    <p><b class="text-black text-decoration-underline">Integrated Program-BCA & MCA </b> –
                        Hardware systems, application software, computer language, and IT management are among the
                        subjects studied in the ARNI School of Technology's BCA and MCA integrated programs, which aid
                        students in gaining knowledge and skills relevant to the workplace. Throughout the three-year
                        undergraduate program, students can expand their knowledge of computer languages and acquire a
                        variety of additional skills. The integrated course lasts five years, whereas the master's
                        program lasts two years.
                    </p>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">First Year
                    </b>: Foundation</p>
                    <ul>
                        <li> Fundamentals of Computer and C-Programming</li>
                        <li> Mathematics-II</li>
                        <li> Digital Logic Mathematics</li>
                        <li> Principles of Management</li>
                        <li> Computer Organization & Architecture</li>
                        <li> Basic Electronics</li>
                        <li> Data Structure</li>
                        <li> Data Structure Labs</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Second Year
                    </b>: Specializations</p>
                    <ul>
                        <li> Mathematics-III</li>
                        <li> Formal Language & Automata Theory</li>
                        <li> Organizational Behavior</li>
                        <li> Operating System</li>
                        <li> Oriented Programming with Java</li>
                        <li> Microprocessors</li>
                        <li> Database Management System</li>
                        <li> Labs</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Third Year
                    </b>: Core Concepts</p>
                    <ul>
                        <li> Mathematics-III</li>
                        <li> Web Technology</li>
                        <li> Computer Networks Laboratory</li>
                        <li> Software Engineering</li>
                        <li> Data Communication & Networks</li>
                        <li> Web Technology Laboratory</li>
                        <li> Projects</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Fourth Year
                    </b>: Applications</p>
                    <ul>
                        <li> Artificial intelligence 4</li>
                        <li> Graph Theory</li>
                        <li> Cryptography and Network Security</li>
                        <li> Design and Analysis of Algorithm 4</li>
                        <li> Algorithm Laboratory</li>
                        <li> Projects</li>
                        <li> Labs</li>
                    </ul>
                </div>

                <div class="col-md-4 col-sm-12">
                    <p><b class="text-decoration-underline text-black">Fifth Year
                    </b>: Research and Dissertation</p>
                    <ul>
                        <li> Operation Research</li>
                        <li> Compiler Design</li>
                        <li> Mobile and Wireless Communication</li>
                        <li> Labs</li>
                        <li> Projects</li>
                        <li> Seminar/Internships</li>
                    </ul>
                </div>

            </div>

        </div>

    </div>
</section>
